import React from 'react';
import PropTypes from 'prop-types';

import { withTranslator } from 'tradera-lang';
import InfoIcon from '@tradera/blueprint/theme/icons2/info.svg?jsx';
import DialogModal from 'tradera-components/dialog/dialog-modal';

class GdprSettingsModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gdprSettings: props.gdprSettings
        };
    }

    save = () => {
        const { saveHandler } = this.props;
        const {
            gdprSettings: { performance, functional, marketing }
        } = this.state;

        let label;
        if (performance && functional && marketing) {
            label = 'Save All';
        } else {
            label =
                'Save ' +
                [
                    performance && 'performance',
                    functional && 'functional',
                    marketing && 'marketing'
                ]
                    .filter(l => l)
                    .join(', ');
        }

        saveHandler(performance, functional, marketing, label);
    };

    handleChange = event => {
        const {
            target: { name, checked }
        } = event;
        this.setState(state => ({
            gdprSettings: {
                ...state.gdprSettings,
                [name]: checked
            }
        }));
    };

    render() {
        const { t } = this.props;
        const { gdprSettings } = this.state;
        return (
            <DialogModal
                className="flex-column"
                dismissOnOverlayClick={false}
                mobileFullscreen={false}
                onDismiss={this.save}
                style={{ width: '40rem' }}>
                <div className="bg-gray-100 rounded-top">
                    <h3 className="text-center m-4">
                        {t('gdprConsent_modalTitle')}
                    </h3>
                </div>
                <div className="text-center px-4 pt-4 pb-0">
                    <p>
                        <InfoIcon className="icon align-text-bottom" />{' '}
                        {t('gdprConsent_whatsThis')}{' '}
                        <a href="https://info.tradera.com/sakerhetscenter/cookies/">
                            {t('gdprConsent_readMore')}
                        </a>
                    </p>
                </div>
                <form className="" onSubmit={this.save}>
                    <div className="px-4 py-2 border-bottom">
                        <div className="form-toggle d-flex align-items-center">
                            <label className="form-toggle-label flex-grow-1 flex-shrink-1 pl-0">
                                <h4 className="mb-0">
                                    {t('gdprConsent_categoryTitle_essential')}
                                </h4>
                            </label>
                            <input
                                type="checkbox"
                                className="form-toggle-input flex-grow-0 flex-shrink-0"
                                checked={true}
                                disabled={true}
                            />
                        </div>
                        <p className="mt-2">
                            {t('gdprConsent_categoryComment_essential')}
                        </p>
                    </div>
                    {Object.entries(gdprSettings).map(
                        ([type, value], index) => (
                            <div key={type} className="px-4 py-2 border-bottom">
                                <div className="form-toggle d-flex align-items-center">
                                    <label
                                        className="form-toggle-label flex-grow-1 flex-shrink-1 pl-0"
                                        htmlFor={`categoryToggle-${type}`}>
                                        <h4 className="mb-0">
                                            {t(
                                                `gdprConsent_categoryTitle_${type}`
                                            )}
                                        </h4>
                                    </label>
                                    <input
                                        type="checkbox"
                                        className="form-toggle-input flex-grow-0 flex-shrink-0"
                                        id={`categoryToggle-${type}`}
                                        name={type}
                                        tabIndex={index}
                                        autoFocus={index === 0}
                                        checked={value}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <p className="mt-2">
                                    {t(`gdprConsent_categoryComment_${type}`)}
                                </p>
                            </div>
                        )
                    )}
                </form>
                <div className="p-4">
                    <button
                        className="btn btn-primary w-100"
                        tabIndex={gdprSettings.length}
                        onClick={this.save}>
                        {t('gdprConsent_save')}
                    </button>
                </div>
            </DialogModal>
        );
    }
}

GdprSettingsModal.propTypes = {
    saveHandler: PropTypes.func.isRequired
};

export default withTranslator(GdprSettingsModal);
